const ALLOWED_TAGS = new Set([
    'a', 'b', 'br', 'button', 'caption', 'col', 'colgroup', 'div', 'em', 'h1', 'h2',
    'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'label', 'li', 'ol', 'p', 'section',
    'small', 'span', 'strong', 'style', 'sub', 'sup', 'table', 'tbody', 'td', 'tfoot',
    'th', 'thead', 'tr', 'u', 'ul'
]);

const FORBIDDEN_ATTR = /^(on\w+|formaction|xmlns|xlink:href)$/i;
const UNSAFE_URL = /^\s*(javascript|data|vbscript):/i;

export const escapeHtml = (text) => {
    if (text == null) {
        return '';
    }

    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

const sanitizeNode = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
        return document.createTextNode(node.textContent);
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
        return document.createDocumentFragment();
    }

    const tag = node.tagName.toLowerCase();
    if (!ALLOWED_TAGS.has(tag)) {
        const fragment = document.createDocumentFragment();
        [...node.childNodes].forEach((child) => {
            appendSanitizedChild(fragment, sanitizeNode(child));
        });
        return fragment;
    }

    const element = document.createElement(tag);
    [...node.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value;

        if (FORBIDDEN_ATTR.test(name)) {
            return;
        }

        if ((name === 'href' || name === 'src') && UNSAFE_URL.test(value)) {
            return;
        }

        element.setAttribute(name, value);
    });

    [...node.childNodes].forEach((child) => {
        appendSanitizedChild(element, sanitizeNode(child));
    });

    return element;
};

const appendSanitizedChild = (parent, child) => {
    if (child.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        [...child.childNodes].forEach((nestedChild) => parent.appendChild(nestedChild));
        return;
    }

    parent.appendChild(child);
};

export const sanitizeHtml = (html) => {
    if (html == null || html === '') {
        return '';
    }

    const doc = new DOMParser().parseFromString(String(html), 'text/html');
    const container = document.createElement('div');

    [...doc.body.childNodes].forEach((child) => {
        appendSanitizedChild(container, sanitizeNode(child));
    });

    return container.innerHTML;
};

export const decodeHtmlEntities = (encodedHtmlTxt) => {
    if (encodedHtmlTxt == null || encodedHtmlTxt === '') {
        return '';
    }

    try {
        const text = decodeURIComponent(String(encodedHtmlTxt));
        return text
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&#x27;/gi, "'")
            .replace(/&amp;/g, '&');
    } catch (error) {
        return '';
    }
};

export const appendSanitizedHtml = (parent, html) => {
    if (html == null || html === '') {
        return;
    }

    const doc = new DOMParser().parseFromString(String(html), 'text/html');

    [...doc.body.childNodes].forEach((child) => {
        appendSanitizedChild(parent, sanitizeNode(child));
    });
};

export const getPostMessageTargetOrigin = () => window.location.origin;
